import DetailPoints from "../DetailPoints";
import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointIrcantec = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };

  return (
    <>      {context.state['Carriere'+ClientConjoint].filter((Carriere) => (Carriere.Nature === "ActiviteSalarie" || Carriere.Nature === "SalarieIrcantec")).length > 0 && (        <div className="card">
          <div className="category-column">
            IRCANTEC
          </div>
          <div className="value-column">
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].RetraiteCompIrcantec}
              onChange={(e)=>{context.handlePointRetraite(ClientConjoint,"RetraiteCompIrcantec",e)}}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              normal
            />
          </div>
          <div className="value-column">
            <DropDown
              value={context.state["TableauPoints" + ClientConjoint].AnneeFinIrcantec}
              onChange={(e)=>{
                context.handlePointRetraite(ClientConjoint,"AnneeFinIrcantec",e)
                props.CalculRetraite();
              }}
              options={[
                { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
              ]}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={resultRetraite?.InfosRetraite?.Ircantec?.General?.PointCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Ircantec?.General?.PointCalcule}
              disabled={true}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              normal
            />
            <DetailPoints caisse="Ircantec" regime="Complementaire" champ="PointCalcule" libelle="IRCANTEC" />
          </div>
        </div>
      )}
    </>
  );
};
export default PointIrcantec;
